import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { VariableMenuItem } from '../../common/components/variable-menu.component';
import { AutomationVariableMenuItemSelectorComponent } from '../../common/components/automation-variable-menu/automation-variable-menu-item-selector/automation-variable-menu-item-selector.component';

interface DialogData {
  namespace: string;
  menuItems: VariableMenuItem[];
}

@Component({
  template: `
    <h2 mat-dialog-title>
      {{ 'HTML_EDITOR.DYNAMIC_CONTENT.ADD_DYNAMIC_CONTENT' | translate }}
    </h2>
    <div class="pseudo-dialog">
      <div class="pseudo-dialog-content">
        <automata-variable-menu-item-selector
          [items]="data.menuItems"
          [parentTextKey]="'COMMON.CATEGORY' | translate"
          parentLabelHintKey="HTML_EDITOR.DYNAMIC_CONTENT.CATEGORY_DESCRIPTION"
          (variableMenuItemSelected)="variableMenuItemSelected($event)"
        ></automata-variable-menu-item-selector>
      </div>
      <div class="actions">
        <div>
          <button mat-stroked-button mat-dialog-close>
            {{ 'AUTOMATIONS.COMMON.CANCEL' | translate }}
          </button>
          <button mat-raised-button color="primary" (click)="add()" [disabled]="!chosenVariableMenutItem">
            {{ 'COMMON.ACTION_LABELS.ADD' | translate }}
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./variable-menu-dialog.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    GalaxyAlertModule,
    MatFormFieldModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    GalaxyWrapModule,
    AutomationVariableMenuItemSelectorComponent,
  ],
})
export class VariableMenuDialogComponent {
  chosenVariableMenutItem: VariableMenuItem = null;
  constructor(
    public dialogRef: MatDialogRef<VariableMenuDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  add(): void {
    const content = this.chosenVariableMenutItem?.settings?.shouldNotSurroundWithCurlyBraces
      ? this.chosenVariableMenutItem.replacementTag
      : '{{ ' + this.chosenVariableMenutItem.replacementTag + ' }}';
    this.dialogRef.close(content);
  }

  variableMenuItemSelected(variableMenuItem: VariableMenuItem): void {
    this.chosenVariableMenutItem = variableMenuItem;
  }
}
